import PERM from 'constants/core/perm.const';
import compareArrays from 'utils/arrays/compareArrays.util';
import sortArray from 'utils/arrays/sortedArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromBeToBody from 'utils/converters/backend/fromBeToBody.util';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import { nowAsIso } from 'utils/date/now.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import logger from 'utils/logger.util';
import parseJwt from 'utils/parsers/parseJwt';
import { isValidId } from 'utils/predicates/fields.util';

const L = logger('reducePinPass');

const USE_MOCK = false;

const MOCK = Object.freeze([
  // NOTE: one can pre-fill this for local development, but don't commit the change
  // PERM.canEditKpisPersonal,
]).map((p) => p.index);

const determineId = (options) => (isValidId(options?.value) ? options?.value : 0);

const fromUnixSecondsToIso = (exp) => fromAnyDateToIso(exp * 1000);

export const reducePinPass = (state, action) => {
  const lockToken = fromBeToBody(action)?.slave_token;
  const isSameToken = state?.lockToken === lockToken;

  if (isSameToken) return state;

  const parsed = parseJwt(lockToken);
  const next = sortArray(USE_MOCK ? MOCK : parsed?.cp);
  const prev = state?.permIds;

  const isSamePerms = compareArrays(prev, next);

  const perms = isSamePerms
    ? state.perms
    : next
        .map((index) => {
          const permission = PERM[index];
          if (!permission) L.warn('Missing permission for index:', index, 'in', PERM);
          return permission;
        })
        .filter(alwaysSame);

  L.debug('()', prev, '->', next, '|', parsed);

  return {
    ...state,
    expiresAt: fromUnixSecondsToIso(parsed?.exp),
    lockToken,
    lastUpdate: nowAsIso(),
    permissionType: fromAnyToTrimmed(parsed?.permission_type),
    permIds: isSamePerms ? prev : next,
    perms,
    salonId: determineId({ value: parsed?.salon_id }),
    stylistId: determineId({ value: parsed?.stylist_id }),
    userId: determineId({ value: parsed?.user_id }),
  };
};
